__webpack_require__.p = "/diagnostico/";